import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const QuickAssistIcon = ({ color = '#3F3F3F' }: Props) => (
  <Svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <Path
      d="M8.25 12.75L9.75 14.25C9.89774 14.3977 10.0731 14.5149 10.2662 14.5949C10.4592 14.6748 10.6661 14.716 10.875 14.716C11.0839 14.716 11.2908 14.6748 11.4838 14.5949C11.6769 14.5149 11.8523 14.3977 12 14.25C12.1477 14.1023 12.2649 13.9269 12.3449 13.7338C12.4248 13.5408 12.466 13.3339 12.466 13.125C12.466 12.9161 12.4248 12.7092 12.3449 12.5162C12.2649 12.3231 12.1477 12.1477 12 12"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M10.5002 10.5004L12.3752 12.3754C12.6735 12.6737 13.0782 12.8414 13.5002 12.8414C13.9221 12.8414 14.3268 12.6737 14.6252 12.3754C14.9235 12.077 15.0912 11.6723 15.0912 11.2504C15.0912 10.8284 14.9235 10.4237 14.6252 10.1254L11.7152 7.21538C11.2933 6.79403 10.7214 6.55736 10.1252 6.55736C9.52892 6.55736 8.95705 6.79403 8.53517 7.21538L7.87517 7.87538C7.5768 8.17375 7.17213 8.34137 6.75017 8.34137C6.32821 8.34137 5.92354 8.17375 5.62517 7.87538C5.3268 7.57701 5.15918 7.17233 5.15918 6.75038C5.15918 6.32842 5.3268 5.92375 5.62517 5.62538L7.73267 3.51788C8.41685 2.83549 9.30909 2.40079 10.2682 2.28261C11.2272 2.16442 12.1983 2.3695 13.0277 2.86538L13.3802 3.07538C13.6995 3.26812 14.0792 3.33497 14.4452 3.26288L15.7502 3.00038"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M15.75 2.25L16.5 10.5H15"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M2.25 2.25L1.5 10.5L6.375 15.375C6.67337 15.6734 7.07804 15.841 7.5 15.841C7.92196 15.841 8.32663 15.6734 8.625 15.375C8.92337 15.0766 9.09099 14.672 9.09099 14.25C9.09099 13.828 8.92337 13.4234 8.625 13.125"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M2.25 3H8.25"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default QuickAssistIcon;
